/**
 * DICOM Value Representation (VR) maximum lengths
 * Based on DICOM PS3.5 standard
 */
export enum DicomVRMaxLength {
    SHORT = 16, // Short String (SH)
    LONG = 64, // Long String (LO)
    // Short Text (ST). NOTE: Long Text (LT) is 10240, not this — and
    // neither is subject to `dicomStringViolation`, which forbids the
    // backslash and control characters that ST and LT both allow, and
    // trims spaces that are significant in ST.
    TEXT = 1024,
}

/**
 * DICOM Approval Status values
 * Used for structure set approval workflow
 */
export enum DICOMApprovalStatus {
    UNAPPROVED = 'UNAPPROVED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

/**
 * Returns true when a structure with the given approval status may be edited
 * (renamed, recolored, retyped, etc.).
 *
 * The exhaustive switch — with no default — ensures TypeScript will report a
 * compile error if a new DICOMApprovalStatus value is added without explicitly
 * deciding whether it allows editing.
 */
export function isApprovalStatusEditable(status: DICOMApprovalStatus): boolean {
    switch (status) {
        case DICOMApprovalStatus.UNAPPROVED:
        case DICOMApprovalStatus.REJECTED:
            return true;
        case DICOMApprovalStatus.APPROVED:
            return false;
    }
}
